import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LanguageService } from '../services/language.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { StorageData, User } from '@job-v2/ats-utils';
import { APPLICATION_NAME_HEADER, COMPANY_ID_HEADER, StatesService, StateStoreKeys } from '@socium/sociumflow';
import { Applications, OBSERVABILITY_HEADERS } from '@socium/common-api';
@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor, OnDestroy {
  private readonly statesService = inject(StatesService);
  private readonly languageService = inject(LanguageService);
  private readonly translateService = inject(TranslateService);
  private userLang = this.languageService.getUserLang();
  private readonly subscription = new Subscription();

  constructor() {
    this.listenChangeLanguage();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (req.url.includes(environment.s3Url) || req.url.includes('-minio')) {
      return next.handle(req);
    }

    const authData = this.statesService.getCookie<StorageData>(StateStoreKeys.TOKEN_NAME);
    if (!authData?._accessToken) {
      return next.handle(req);
    }

   const authUser = this.statesService.getCurrentUser() as unknown as User | null;
    const selectedCompanyId =
      this.statesService.getCookie<string>(StateStoreKeys.SELECTED_COMPANY_ID) ?? '';
    const authorId = authUser?._id ?? '';

    let workspaceHeaders = req.headers
      .set('Authorization', `Bearer ${authData._accessToken}`)
      .set('accept-language', this.userLang)
      .set(APPLICATION_NAME_HEADER, Applications.WORKSPACE)
      .set(OBSERVABILITY_HEADERS.CLIENT_ID, selectedCompanyId)
      .set(OBSERVABILITY_HEADERS.AUTHOR_ID, authorId);
    if (selectedCompanyId) {
      workspaceHeaders = workspaceHeaders.set('company-id', selectedCompanyId);
    }

    let jobHeaders = req.headers
      .set('Authorization', `Bearer ${authData._accessToken}`)
      .set('x-api-key', environment.apiKey)
      .set('x-language', this.userLang)
      .set('accept-language', this.userLang)
      .set(APPLICATION_NAME_HEADER, Applications.JOB)
      .set(OBSERVABILITY_HEADERS.CLIENT_ID, selectedCompanyId)
      .set(OBSERVABILITY_HEADERS.AUTHOR_ID, authorId);
    if (selectedCompanyId) {
      jobHeaders = jobHeaders.set(COMPANY_ID_HEADER, selectedCompanyId);
    }

    const authReq = req.url.includes(environment.workSpaceEndpoint)
      ? req.clone({ headers: workspaceHeaders })
      : req.clone({ headers: jobHeaders });

    return next.handle(authReq);
  }

  private listenChangeLanguage(): void {
    const translationSubscription =
      this.translateService.onLangChange.subscribe(
        (langChangeEvent: LangChangeEvent) => {
          this.userLang = langChangeEvent.lang;
        },
      );
    this.subscription.add(translationSubscription);
  }
}
